import { uploadFile } from './api';

const _export = { uploadFile };
export default _export;
